import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppNavigation } from '../../hooks';
import { Button } from '../ui';
import './SpecialOffer.css';

const AUTO_HIDE_DELAY = 15000; // 15 seconds

/**
 * Special offer popup component
 * Shows a promotional message and auto-hides after a delay
 */
const SpecialOffer: React.FC = () => {
	const { t } = useTranslation();
	const { goToFreeEstimate } = useAppNavigation();
	const [isVisible, setIsVisible] = useState(true);

	const handleClose = () => {
		setIsVisible(false);
	};

	// Auto-hide after delay
	useEffect(() => {
		const timer = setTimeout(() => {
			setIsVisible(false);
		}, AUTO_HIDE_DELAY);

		return () => clearTimeout(timer);
	}, []);

	if (!isVisible) {
		return null;
	}

	return (
		<aside className="special-offer" role="complementary" aria-label="Special offer">
			<div className="offer-card">
				<button
					className="offer-close"
					onClick={handleClose}
					aria-label="Close offer"
					type="button"
				>
					×
				</button>
				<div className="offer-content">
					<span className="offer-badge">🔥 {t('common.specialOffer', 'Special Offer')}</span>
					<h3>{t('offer.noTravel', 'No Travel Fees')}</h3>
					<h4>{t('offer.within50', 'Within 50 Miles')}</h4>
					<ul className="offer-list">
						<li>✓ {t('offer.noHidden', 'No hidden charges')}</li>
						<li>✓ {t('offer.exclusive', 'Exclusive discounts')}</li>
						<li>✓ {t('offer.freeSetup', 'Free tables & chairs')}</li>
					</ul>
					<p className="offer-note">
						{t('offer.sunFri', 'Sunday to Friday Special!')}
					</p>
					<Button variant="primary" size="md" onClick={goToFreeEstimate} className="offer-cta">
						{t('nav.freeEstimate')}
					</Button>
				</div>
			</div>
		</aside>
	);
};

export default SpecialOffer;
